import script from "./GameButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameButton.vue?vue&type=script&setup=true&lang=ts"

import "./GameButton.vue?vue&type=style&index=0&id=0221ce94&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0221ce94"]])

export default __exports__